import capitalize from 'lodash-es/capitalize'

import { convertStringToAlphanumeric } from '@fourthwall/utils/dist/string'

import type { WebhookType } from '../Webhooks.types'

const webhookLabels: Partial<Record<WebhookType, string>> = {
  PRODUCT_CREATED: 'Product (offer) created',
  PRODUCT_UPDATED: 'Product (offer) updated',
}

export const getWebhookTypeLabel = (webhookType: WebhookType) =>
  webhookLabels[webhookType] ?? capitalize(convertStringToAlphanumeric(webhookType))
